import BaseModel from './BaseModel';
import Pricing from './Pricing';
import Ref from './Ref';
import * as _ from 'es-toolkit';
import { v4 } from 'uuid';

/** Class representing an pricinglist. */
class Pricinglist extends BaseModel {
    constructor(properties) {
        super(properties);

        this.pricings = this.pricings || {};
        _.mapKeys(this.pricings, (pricing, key) => {
            this.pricings[key] = new Pricing(pricing);
        });
        this.refs = (this.refs || []).map(ref => new Ref(ref));
    }

    /**
     * Prepare this object for update.
     * This is used to "normalize", if needed, some properties
     * before to send them.
     *
     * return{BaseModel}
     */
    prepareForUpdate() {
        const prepared = super.prepareForUpdate();

        prepared.pricings = {};
        _.mapKeys(this.pricings, (pricing, key) => {
            if (!pricing.name)
                return;
            const preparedPricing = pricing.prepareForUpdate();
            if (preparedPricing.name)
                prepared.pricings[key] = preparedPricing;
        });

        if (!('_id' in prepared))
            prepared._id = v4();

        return prepared;
    }

    /**
     * Prepare this object for duplicate.
     * This is used to "normalize", if needed, some properties
     * before to send them.
     *
     * @param {Object} options optional override properties (_id, name)
     * return{BaseModel}
     */
    prepareForDuplicate(options) {
        const prepared = _.cloneDeep(this);

        prepared._id = options?._id || v4();
        if (options && 'name' in options)
            prepared.name = options.name;
        else
            prepared.name += ' copy';

        if ('is_default' in prepared)
            prepared.is_default = false;

        prepared.refs = [];

        return prepared;
    }
}

export default Pricinglist;
